import request from "../../utils/request";
import { Result } from "../../models/general";
import { UserWorkExperienceInput, UserWorkExperienceView } from "../../models/employee";

export async function getUserWorkExperiences(userId: string) {
    const response = await request.get<Result<UserWorkExperienceView[]>>(`WorkExperience/GetUserWorkExperiences/${userId}`);
    return response.data;
}

export async function addUserWorkExperience(input: UserWorkExperienceInput) {
    const response = await request.post<Result<UserWorkExperienceView>>("WorkExperience/AddUserWorkExperience", input);
    return response.data;
}

export async function editUserWorkExperience(workExperienceId: number, input: UserWorkExperienceInput) {
    const response = await request.post<Result<UserWorkExperienceView>>(`WorkExperience/EditUserWorkExperience/${workExperienceId}`, input);
    return response.data;
}

export async function deleteUserWorkExperience(workExperienceId: number) {
    const response = await request.post<Result<UserWorkExperienceView[]>>(`WorkExperience/DeleteUserWorkExperience/${workExperienceId}`);
    return response.data;
}